<template>
  <div class="home-container">
    <div class="nav">
      <Nav ></Nav>
      <!-- 顶部导航 -->
    </div>
    <ul class="indicator">
      <!-- 选择器 -->
      <li v-for="(item, i) in indicatorAll" :class="{ active: i === index }" @click="index = i" :key="i"></li>
    </ul>
    <div class="sw-container" ref="container" @wheel="handleWheel" @transitionend="handelTransitionEnd"
      :style="{ marginTop }">
      <div class="carousel">
        <Banner :addAnimate="addClass"></Banner>
        <!-- 轮播图 -->
      </div>
      <div class="artshare">
        <Artshare></Artshare>
        <!-- 艺术传播 -->
      </div>

      <div class="news">
        <News></News>
        <!-- 新闻 -->
      </div>
      <div class="art">
        <Artist></Artist>
        <!-- 艺术家 -->
      </div>
      <div class="room" >
        <Room :addAnimate="addClass" ></Room>
        <!-- 展厅 -->
      </div>
      <div class="product">
        <Product :addAnimate="addClass" ></Product>
        <!-- 产品 -->
      </div>
      <div class="dataview">
        <Dataview></Dataview>
        <!-- 数据统计 -->
      </div>
      <div class="footer">
        <About :addAnimate="addClass"></About>
        <!-- 关于我们 -->
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './Nav.vue'
import Banner from './Banner.vue'
import Artshare from './Artshare.vue'
import News from './News.vue'
import Artist from './Artist.vue'
import Room from './Room.vue'
import Product from './Product.vue'
import About from './About.vue'
import Dataview from './Dataview.vue'

import bus from '@/components/eventBus'
export default {
  components: {
    Nav,
    Banner,
    Artshare,
    News,
    Artist,
    Room,
    Product,
    About,
    Dataview
  },
  data () {
    return {
      index: 0,
      containerHeight: 0, // 容器高度
      isScroll: false, // 控制滚动
      indicatorAll: 0,
      addClass: ''
    }
  },
  computed: {
    marginTop () {
      return -this.index * this.containerHeight + 'px'
    }
  },
  watch: {
    // 监听index变化，当页面滚动时发送事件通知Nav组件更新active状态
    index(newVal) {
      // 发送事件到Nav组件，通知当前页面索引
      bus.$emit('updateNav', newVal);
    }
  },
  mounted () {
    this.indicatorAll = this.$refs.container.children.length
    bus.$on('change', val => {
      // 接受nav的菜单
      // console.log(val)
      this.index = val
      this.addClass = ''
    })
  },
  updated () {
    this.containerHeight = this.$refs.container.clientHeight
    this.addStyle() // 滚动时添加动画
  },
  methods: {
    handleWheel (e) {
      console.log(this.containerHeight)
      if (this.isScroll) {
        return
      }
      console.log(e)
      if (e.deltaY === -100 && this.index > 0) {
        this.isScroll = true
        this.index -= 1
      } else if (e.deltaY === 100 && this.index < this.$refs.container.children.length - 1) {
        this.isScroll = true
        this.index += 1
        this.addClass = '' // 滚动时清除动画
      }
    },
    handelTransitionEnd () {
      this.isScroll = false
    },
    addStyle () {
      if (this.addClass === '') {
        this.addClass = 'animate__fadeInDown'
      }
    }

  }

}
</script>

<style lang="less" scoped>
.home-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #EFF1FD;
  overflow: hidden;

  .nav {
    position: fixed;
    width: 100%;
    height: 60px;
    padding: 0 32px;
    background-color: rgba(#EFF1FD, .7);
    backdrop-filter: blur(5px);
    box-sizing: border-box;
    z-index: 999;
  }

  .indicator {
    position: absolute;
    top: 50%;
    right: 20px;
    height: auto;
    transform: translateY(-50%);
    z-index: 999;

    li {
      margin: 2px 0px;
      width: 4px;
      height: 14px;
      background-color: #969a9c79;
      border-radius: 2px;
      transition: all .3s;
      cursor: pointer;

      &.active {
        height: 24px;
        background-color: #FF7A3B;
      }
    }
  }

  .sw-container {
    width: 100%;
    height: 100%;
    transition: all .5s;
    text-align: center;

    // overflow: auto;
    .carousel {
      width: 100%;
      height: 100%;
      background: pink;
    }
    .artshare {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }

    .news {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }

    .art {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
            background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }

    .room {
      width: 100%;
      height: 100%;
    }

    .product {
      width: 100%;
      height: 100%;
      background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }
    .dataview{
      width: 100%;
      height: 100%;
      background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }

    .footer {
      width: 100%;
      height: 100%;
          background-image: url(~@/assets/imgs/news.png);
      background-size: cover;
      background-position: center;
    }
  }
}
</style>